<template lang='pug'>
el-dropdown.branch-label(:class='{small}', placement='bottom-start', @command="goto") 
  span {{$config.branch_name}}
  i.el-icon-arrow-down.el-icon--right
  el-dropdown-menu(slot='dropdown')
    el-dropdown-item(v-for='branch in $config.branches', :command='branch.url', :key='branch.url' ) {{branch.name}}
</template>

<script>
export default {
  props: {
    small: null,
  },
  methods: {
    goto(url) {
      window.location = url
    },
  },
}
</script>

<style lang="less">
.branch-label {
  background: rgba(255,255,255,0.15);
  padding: 1px 8px;
  border-radius: 5px;
  color: #fff;
  &.small {
    font-size: 0.8em;
    padding: 2px 5px;
  }
  .el-icon--right {
    font-size: 8px;
    margin-left: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// BranchLabel.vue?3d3c5ce4